import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { contactInfo } from '../data/mockData';

const Footer = () => {
  const { language, t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            {/* About Section */}
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-xl">नि</span>
                </div>
                <div>
                  <h3 className="font-bold text-xl">
                    {language === 'bn' ? 'নিধিবন হোমস্টে' : 'Nidhiwan Homestay'}
                  </h3>
                  <p className="text-orange-400 text-sm">
                    {language === 'bn' ? 'বৃন্দাবন, মথুরা' : 'Vrindavan, Mathura'}
                  </p>
                </div>
              </div>
              <p className="text-gray-400 leading-relaxed">
                {t('footerTagline')}
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-bold text-lg mb-6 text-orange-400">
                {language === 'bn' ? 'দ্রুত লিঙ্ক' : 'Quick Links'}
              </h4>
              <ul className="space-y-3">
                {[
                  { id: 'home', label: t('home') },
                  { id: 'about', label: t('about') },
                  { id: 'gallery', label: t('gallery') },
                  { id: 'amenities', label: language === 'bn' ? 'সুবিধা' : 'Amenities' },
                  { id: 'testimonials', label: language === 'bn' ? 'রিভিউ' : 'Reviews' },
                  { id: 'temples', label: t('temples') },
                  { id: 'contact', label: t('contact') },
                ].map((link) => (
                  <li key={link.id}>
                    <button
                      onClick={() => scrollToSection(link.id)}
                      className="text-gray-400 hover:text-orange-400 transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-bold text-lg mb-6 text-orange-400">
                {t('contact')}
              </h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 text-orange-400 mt-1 flex-shrink-0" />
                  <a 
                    href={`tel:${contactInfo.phone}`}
                    className="text-gray-400 hover:text-orange-400 transition-colors"
                  >
                    {contactInfo.phone}
                  </a>
                </div>
                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-orange-400 mt-1 flex-shrink-0" />
                  <a 
                    href={`mailto:${contactInfo.email}`}
                    className="text-gray-400 hover:text-orange-400 transition-colors break-all"
                  >
                    {contactInfo.email}
                  </a>
                </div>
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-orange-400 mt-1 flex-shrink-0" />
                  <p className="text-gray-400">
                    {language === 'bn' 
                      ? 'গোপীনাথ বাজার, বৃন্দাবন' 
                      : 'Gopinath Bajar, Vrindavan'}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-orange-500 to-transparent mb-8" />

          {/* Bottom Bar */}
          <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
            <p>{t('footerText')}</p>
            <p className="mt-4 md:mt-0">
              {language === 'bn' 
                ? 'প্রেম ও ভক্তি দিয়ে তৈরি' 
                : 'Made with love and devotion'} 
              <span className="text-orange-400 mx-1">❤️</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
